<template>
    <div class="w-100">
        <section class="rates-table-section">
            <div class="container">
                <div class="rates-table-container">
                    <section class="title">
                        <h1>{{ $t('ratesTable.heading') }}</h1>
                        <h6 class="t-bold">{{ $t('ratesTable.subHeading') }}</h6>
                    </section>
                    <section class="rates-table-wrapper container">
                        <div class="row g-0 rates-table">
                            <DynamicRatesTableContainer />
                        </div>
                    </section>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.rates-table-container {
    margin: rem(40px) auto;
    max-width: rem(970px);

    @media screen and (min-width: $bp-large) {
        margin: rem(100px) auto;
    }

    .title {
        text-align: center;

        h1 {
            font-size: rem(30px);
            line-height: rem(36px);
            letter-spacing: -0.01em;
        }

        h6 {
            font-size: rem(18px);
            line-height: rem(22px);
            letter-spacing: -0.025em;
            color: var(--text-default);
            margin-top: rem(40px);
            margin-bottom: rem(40px);
        }
    }
}
</style>
